export const nativeShare = () => {
  const getMetaItem = (type) => document.querySelector(`meta[property='og:${type}']`).getAttribute('content') || false;

  if (navigator.share) {
    const ogTitle = getMetaItem('title');
    const ogDescription = getMetaItem('description');
    const ogUrl = getMetaItem('url');

    if (!ogTitle || !ogDescription || !ogUrl) {
      return false;
    }

    navigator.share({
      title: ogTitle,
      text: ogDescription,
      url: ogUrl,
    });

    return true;
  }
  return false;
};
